import React, { useState } from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: ${({ theme }) => theme.spacing.md} ${({ theme }) => theme.spacing.xl};
  background: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.small};
  z-index: 1000;
  transition: ${({ theme }) => theme.transitions.default};
  height: 100px;
  display: flex;
  align-items: center;
  scroll-margin-top: 100px;
`;

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: ${({ theme }) => theme.breakpoints.wide};
  margin: 0 auto;
  width: 100%;
`;

const Logo = styled.img`
  height: 100%;
  width: 200px;
  max-height: 100px;
  object-fit: contain;
  margin-right: 1rem;
  transition: ${({ theme }) => theme.transitions.default};
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    max-height: 80px;
    width: 150px;
  }

  &:hover {
    filter: brightness(1.1);
  }
`;

const MenuItems = styled.ul<{ isOpen: boolean }>`
  display: flex;
  list-style: none;
  gap: ${({ theme }) => theme.spacing.xl};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: ${({ theme }) => theme.colors.white};
    padding: ${({ theme }) => theme.spacing.lg};
    box-shadow: ${({ theme }) => theme.shadows.medium};
  }
`;

const MenuItem = styled.li`
  a {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.gray.dark};
    transition: ${({ theme }) => theme.transitions.default};

    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

const MenuButton = styled.button`
  display: none;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.primary};
  background: none;
  border: none;
  cursor: pointer;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: block;
  }
`;

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuItems = [
    { label: 'Home', href: '#home' },
    { label: 'About', href: '#about' },
    { label: 'Products', href: '#products' },
    { label: 'Contact', href: '#contact' },
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const headerHeight = 60; // 100px header (removed the 10px offset)
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <HeaderContainer>
      <Nav>
        <Logo src="/JupiterLogo.jpg" alt="Jupiter & Co" />
        <MenuButton onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? '✕' : '☰'}
        </MenuButton>
        <MenuItems isOpen={isMenuOpen}>
          {menuItems.map((item) => (
            <MenuItem key={item.label}>
              <a href={item.href} onClick={(e) => {
                e.preventDefault();
                setIsMenuOpen(false);
                scrollToSection(item.href.substring(1));
              }}>{item.label}</a>
            </MenuItem>
          ))}
        </MenuItems>
      </Nav>
    </HeaderContainer>
  );
};

export default Header; 